module.exports = __webpack_public_path__ + "402facdbc7044d9865afe1cccb2d9c3e.png";